import React from "react";
import { connect } from "react-redux";
import moment from "moment";

import Content from "../../../components/Export/Content";
import Column from "../../../components/Export/Column";
import Table from "../../../components/Export/Table";
import Table2 from "../../../components/Export/Table2";
import Row from "../../../components/Export/Row";

import "./ClockInOutSummary.css";
import Spinner from "../../../components/UI/Spinner/Spinner";
import Filter from "../../../helpers/Filter";
import Axios from "axios";
import NoData from "../../../components/UI/Spinner/NoData";
import Configs from "../../../Configs";

const styleRow = {};

const styleRowTotal = {
  borderBottom: "2px solid #f4f4f4",
  borderTop: "2px solid #f4f4f4",
};

const titleCol = {
  CONTROLLER: "Controller",
  ORDER_NO: "Order/Receipt No",
  TOTAL_NET_SALE: "Total Net Sale (Bill/Receipt)",
  ITEM_NET_SALE: "Calculated Total Item Net Sales (Items)",
};
const titleTotal = {
  BILL_RECEIPT: "Bill/Receipt",
  ITEMS: "Items",
  DISCREPANCY: "Discrepancy",
  SUB: "SubTotal",
};
const datetimeCol = {
  DATE: "Date",
  TIME: "Time",
  CREATE_TIME: "Create Time",
  PAYMENT_TIME: "Payment Time",
  TIME_DIFFERENCE: "Time Difference",
};

class DicrepancyImportSummary extends React.PureComponent {
  state = {
    reports: [],
    analysis: {},
    loading: false,
    noFile: false,
  };

  componentDidMount() {
    this.setState({
      loading: true,
    });
    Axios.get(`${this.props.file}`)
      .then((res) => {
        this.setState({
          analysis: res.data,
          loading: false,
          noFile: false,
        });
      })
      .catch((res) => {
        this.setState({
          loading: false,
          noFile: true,
        });
      });
  }

  exportPdf = () => {
    let view = document.getElementById("exportReceptBill").innerHTML;
    let popupWinindow = window.open(
      "",
      "_blank",
      "width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no"
    );
    popupWinindow.document.open();
    popupWinindow.document.write(
      '<html><head><link rel="stylesheet" type="text/css" href="' +
        Configs.abossUrl +
        '/assets/css/bootstrap.min.css" /></head><body onload="window.print()">' +
        view +
        "</html>"
    );
    popupWinindow.document.close();
  };

  setTotalTable = (results, paidType, period) => {
    let values = [];
    const rows = ["Total Bill", "Total Net Sales"];
    const rowsLength = rows.length;
    for (let i = 0; i < rowsLength; i++) {
      const title = rows[i];
      const keyBillReceipt =
        "Period_" +
        period +
        "_" +
        title +
        "_" +
        paidType +
        "_" +
        titleTotal.BILL_RECEIPT;
      const billReceipt =
        results[keyBillReceipt] != undefined ? results[keyBillReceipt] : 0;
      const keyItems =
        "Period_" +
        period +
        "_" +
        title +
        "_" +
        paidType +
        "_" +
        titleTotal.ITEMS;
      const items = results[keyItems] != undefined ? results[keyItems] : 0;
      const keyDiscrepancies =
        "Period_" +
        period +
        "_" +
        title +
        "_" +
        paidType +
        "_" +
        titleTotal.DISCREPANCY;
      const discrepancies =
        results[keyDiscrepancies] != undefined ? results[keyDiscrepancies] : 0;
      if (title == "Total Bill") {
        values.push({
          name: title,
          val: [billReceipt, items, discrepancies],
        });
      } else {
        values.push({
          name: title,
          val: [
            Filter.displayCurrency(billReceipt),
            Filter.displayCurrency(items),
            Filter.displayCurrency(discrepancies),
          ],
        });
      }
    }

    if (values.length <= 0) {
      return (
        <Table2 title={""}>
          <tr>
            <td colSpan="4">
              <b>No Data Available</b>
            </td>
          </tr>
        </Table2>
      );
    }

    return (
      <Table2 title={""} col={4}>
        <Row
          styleRow={styleRowTotal}
          name={""}
          values={["Bill/Receipt", "Items", "Discrepancy"]}
        ></Row>
        {values.map((value, key) => {
          return (
            <Row
              key={key}
              styleRow={styleRow}
              name={value.name}
              values={value.val}
            ></Row>
          );
        })}
      </Table2>
    );
  };

  setDetailTable = (results, paidType, period) => {
    let values = [];
    const keyDiscrepancies = "Period_" + period + "_" + paidType;
    const discrepancies =
      results[keyDiscrepancies] != undefined ? results[keyDiscrepancies] : {};
    const discrepancyArray = Object.values(discrepancies);
    const discrepancyArrayLength = discrepancyArray.length;
    for (let i = 0; i < discrepancyArrayLength; i++) {
      const discrepancy = discrepancyArray[i];
      const controller =
        discrepancy[titleCol.CONTROLLER] != undefined
          ? discrepancy[titleCol.CONTROLLER]
          : "";
      const date =
        discrepancy[datetimeCol.DATE] != undefined
          ? discrepancy[datetimeCol.DATE]
          : "";
      const time =
        discrepancy[datetimeCol.TIME] != undefined
          ? discrepancy[datetimeCol.TIME]
          : "";
      const orderNo =
        discrepancy[titleCol.ORDER_NO] != undefined
          ? discrepancy[titleCol.ORDER_NO]
          : "";
      const sub =
        discrepancy[titleCol.SUB] != undefined ? discrepancy[titleCol.SUB] : "";
      const totalNetSale =
        discrepancy[titleCol.TOTAL_NET_SALE] != undefined
          ? discrepancy[titleCol.TOTAL_NET_SALE]
          : "";
      const itemNetSale =
        discrepancy[titleCol.ITEM_NET_SALE] != undefined
          ? discrepancy[titleCol.ITEM_NET_SALE]
          : "";

      const dateYYYYMMDD = date.split(/\D/).reverse().join("-");

      values.push({
        name: controller.substring(0, 8),
        val: [
          date,
          time,
          orderNo,
          Filter.displayCurrency(sub),
          Filter.displayCurrency(totalNetSale),
          Filter.displayCurrency(itemNetSale),
        ],
        urls: [
          false,
          false,
          false,
          `/object/dailyReport?controller=${controller}&startTime=${dateYYYYMMDD}`,
          `/object/dailyReport?controller=${controller}&startTime=${dateYYYYMMDD}`,
          `/object/order?controller=${controller}&order=${orderNo}`,
        ],
      });
    }

    if (values.length <= 0) {
      return (
        <Table2 title={""}>
          <tr>
            <td colSpan="7">
              <b>No Data Available</b>
            </td>
          </tr>
        </Table2>
      );
    }

    return (
      <Table2 title={""} col={7}>
        <Row
          styleRow={styleRowTotal}
          name={"Controller (First 8 Chars)"}
          values={[
            "Date",
            "Time",
            "Order/Receipt No",
            "Sub Total",
            "Total Net Sale (Bill/Receipt)",
            "Calculated Total Item Net Sale (Items)",
          ]}
        ></Row>
        {values.map((value, key) => {
          return (
            <Row
              isUrl={true}
              urls={value.urls}
              key={key}
              styleRow={styleRow}
              name={value.name}
              values={value.val}
            ></Row>
          );
        })}
      </Table2>
    );
  };

  setWarningDetailTable = (results, paidType, period) => {
    let values = [];
    const keyDiscrepancies = "Period_" + period + "_" + paidType;
    const warnings =
      results[keyDiscrepancies] != undefined ? results[keyDiscrepancies] : [];
    const warningsLength = warnings.length;
    for (let i = 0; i < warningsLength; i++) {
      const warning = warnings[i];
      const controller =
        warning[titleCol.CONTROLLER] != undefined
          ? warning[titleCol.CONTROLLER]
          : "";
      const orderNo =
        warning[titleCol.ORDER_NO] != undefined
          ? warning[titleCol.ORDER_NO]
          : "";
      const createTime =
        warning[datetimeCol.CREATE_TIME] != undefined
          ? warning[datetimeCol.CREATE_TIME]
          : "";
      const paymentTime =
        warning[datetimeCol.PAYMENT_TIME] != undefined
          ? warning[datetimeCol.PAYMENT_TIME]
          : "";
      const timeDifferent =
        warning[datetimeCol.TIME_DIFFERENCE] != undefined
          ? warning[datetimeCol.TIME_DIFFERENCE] + "ms"
          : "";
      const totalNetSale =
        warning[titleCol.TOTAL_NET_SALE] != undefined
          ? warning[titleCol.TOTAL_NET_SALE]
          : "";

      values.push({
        name: controller.substring(0, 8),
        val: [
          orderNo,
          moment(createTime).format("DD-MM-YYYY HH:mm:ss"),
          moment(paymentTime).format("DD-MM-YYYY HH:mm:ss"),
          timeDifferent,
          Filter.displayCurrency(totalNetSale),
        ],
      });
    }

    if (values.length <= 0) {
      return (
        <Table2 title={""}>
          <tr>
            <td colSpan="6">
              <b>No Data Available</b>
            </td>
          </tr>
        </Table2>
      );
    }

    return (
      <Table2 title={"Warning"} col={6}>
        <Row
          styleRow={styleRowTotal}
          name={"Controller (First 8 Chars)"}
          values={[
            "Order/Receipt No",
            "Create Time",
            "Payment Time",
            "Time Difference",
            "Total Net Sale (Bill/Receipt)",
          ]}
        ></Row>
        {values.map((value, key) => {
          return (
            <Row
              isUrl={true}
              urls={value.urls}
              key={key}
              styleRow={styleRow}
              name={value.name}
              values={value.val}
            ></Row>
          );
        })}
      </Table2>
    );
  };

  render() {
    let content = <Spinner></Spinner>;

    if (this.state.noFile) {
      return <NoData></NoData>;
    }

    if (!this.state.loading && Object.keys(this.state.analysis).length > 0) {
      const analysis = { ...this.state.analysis };

      const periods = [...analysis.periods];
      let controllerNames = { ...analysis.controllerNames };
      const controllers = [...analysis.controllers];
      const controllersName = [];
      const controllersLength = controllers.length;
      for (let i = 0; i < controllersLength; i++) {
        if (controllerNames[controllers[i]] !== undefined) {
          controllersName.push(controllerNames[controllers[i]]);
        }
      }

      const summaries = { ...analysis.summaries };
      const discrepancies = { ...analysis.discrepancies };
      const warnings = { ...analysis.warnings };
      const payTypes = [...analysis.paidType];

      content = periods.map((period, key) => {
        const start = period.range.start;
        const end = period.range.end;
        const description = `FROM ${moment(+start).format("LLL")} TO ${moment(
          +end
        )
          .subtract(1, "minutes")
          .format("LLL")}`;

        const contentChild = payTypes.map((payType, key) => {
          return (
            <React.Fragment>
              <table
                key={key}
                style={{
                  width: "100%",
                }}
              >
                <tbody>
                  <tr>
                    <Column
                      style={{
                        margin: "10px 0px 0px 0px",
                        background: "white",
                        verticalAlign: "top",
                        width: "100%",
                      }}
                    >
                      {this.setTotalTable(summaries, payType, period.name)}
                    </Column>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr
                    style={{
                      borderTop: "2px solid black",
                    }}
                  >
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                </tbody>
              </table>
              <table
                key={key}
                style={{
                  width: "100%",
                }}
              >
                <tbody>
                  <tr>
                    <Column
                      style={{
                        margin: "10px 0px 0px 0px",
                        background: "white",
                        verticalAlign: "top",
                        width: "100%",
                      }}
                    >
                      {this.setDetailTable(discrepancies, payType, period.name)}
                    </Column>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr
                    style={{
                      borderTop: "2px solid black",
                    }}
                  >
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                </tbody>
              </table>
              <table
                key={key}
                style={{
                  width: "100%",
                }}
              >
                <tbody>
                  <tr>
                    <Column
                      style={{
                        margin: "10px 0px 0px 0px",
                        background: "white",
                        verticalAlign: "top",
                        width: "100%",
                      }}
                    >
                      {this.setWarningDetailTable(
                        warnings,
                        payType,
                        period.name
                      )}
                    </Column>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr
                    style={{
                      borderTop: "2px solid black",
                    }}
                  >
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                </tbody>
              </table>
            </React.Fragment>
          );
        });

        return (
          <Content
            title="DISCREPANCY SUMMARY"
            description={description}
            controllers={controllersName.join(", ")}
          >
            {contentChild}
          </Content>
        );
      });
    }

    return (
      <div className="DicrepancySummary">
        <div className="row">
          <div className="col-md-12 col-xs-12 col-lg-12">
            <button className="btn btn-primary" onClick={this.exportPdf}>
              <i className="fa fa-print"></i>
              Print
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-xs-12 col-lg-12">
            <div id="exportReceptBill">{content}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default DicrepancyImportSummary;
